export default __webpack_public_path__ + "static/media/logo-white.6448d612.svg";